// 仮データ（削除予定）
export default {
  name: '大阪ビューティー専門学校',
  texts: {},
  supportBanners: []
}
